import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { isEqual } from '../../utils/lodash';

import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import JelListViewBtn from './components/JelListViewBtn';

const ViewUsesTree = ({ loaded, node, data, classes, setUsedViewsToParent }) => {
  const [isWrapped, setIsWrapped] = useState(true);
  const [usedViews, setUsedViews] = useState({});
  const componentRef = useRef(null);

  useEffect(() => {
    if (setUsedViewsToParent) setUsedViewsToParent(usedViews);
  }, [usedViews]);

  const handleChange = useCallback((newNodeId) => {
    setUsedViews((previousState) => ({
      ...previousState,
      [newNodeId]: data[newNodeId],
    }));
  }, []);

  const renderNode = (nodeId, visitedNodes = {}) => {
    const currentVisitCount = visitedNodes[nodeId] || 0;
    if (currentVisitCount >= 1) {
      console.warn(`Loop detected at node: ${nodeId}`);
      return null;
    }

    visitedNodes[nodeId] = currentVisitCount + 1;

    const currentView = data[nodeId];
    if (!currentView || typeof currentView !== 'object') return null;
    if(!isEqual(currentView, usedViews[nodeId])) handleChange(nodeId, currentView);

    return (
      <div style={{ marginLeft: '20px' }}>
        <JelListViewBtn
          viewData={{ type: currentView.type, title: `${currentView.id} ${currentView.title}`, id: currentView.id }}
          openViewInNewTab={true}
        />

        {currentView.show_pids ?
          <React.Fragment>
            {currentView.show_pids.map((column, index) => {
              if (column && column.obj_editable_frm) return <div key={index}>{renderNode(column.obj_editable_frm, visitedNodes)}</div>
            })}
          </React.Fragment>
        : null}

        {currentView.buttons ?
          <div>
            {currentView.buttons.editNode && renderNode(currentView.buttons.editNode, visitedNodes)}
          </div>
        : currentView.groups && currentView.groups.map((row, rowIndex) => (
          <div key={`${rowIndex} ${currentView.id}`}>
            {row.map((group, index) => (
              <div key={`${index} ${currentView.id} ${nodeId}`}>
                {group.items && renderItems(group.items, visitedNodes)}
                {group.links && renderLinks(group.links, visitedNodes)}
                {group.tableId && renderNode(group.tableId, visitedNodes)}
                {group.frmId && renderNode(group.frmId, visitedNodes)}
                {group.frmEditId && renderNode(group.frmEditId, visitedNodes)}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const renderItems = (items, visitedNodes) => items.map((item, index) => {
    if (!item.obj_editable_frm) return null;
    return <div key={`${index} ${item.obj_editable_frm}`}>{renderNode(item.obj_editable_frm, visitedNodes)}</div>;
  });

  const renderLinks = (links, visitedNodes) => links.map((link, index) => {
    if (!data[link.jel]) return null;
    return <div key={`${index} ${link.jel}`}>{renderNode(link.jel, visitedNodes)}</div>;
  });

  useEffect(() => {
    const componentHeight = componentRef.current.clientHeight;
    if (componentHeight < 150) {
      setIsWrapped(false);
    }
    if (loaded) setUsedViews({});
  }, [loaded]);

  const toggleWrap = () => setIsWrapped(prev => !prev);

  return (
    <React.Fragment>
      <div ref={componentRef} style={{ maxHeight: isWrapped ? '150px' : 'none', overflow: 'hidden' }}>
        <div>{useMemo(() => renderNode(node), [node])}</div>
      </div>
      {isWrapped ? (
        <div
          className={`${classes.alignJustifyCenter} ${classes.ml30} ${classes.p5}`}
          style={{ fontSize: 10 }}
          onClick={toggleWrap}
        >
          <button size="small" style={{ color: '#347CFF' }}>Show More</button>
          <KeyboardArrowDownRoundedIcon style={{ color: '#347CFF' }}/>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default ViewUsesTree;
